import React from "react";
import { twMerge } from "tailwind-merge";

const Card = React.forwardRef(
  ({ variant = "default", hover = false, className, children, ...props }, ref) => {
    const baseStyles = `
    rounded-lg border transition-all duration-200
  `;

    const variants = {
      default: `
      bg-white border-neutral-200 shadow-card
    `,
      info: `
      bg-info/5 border-info/20 text-info-900
    `,
      success: `
      bg-success/5 border-success/20 text-success-900
    `,
      warning: `
      bg-warning/5 border-warning/20 text-warning-900
    `,
      error: `
      bg-error/5 border-error/20 text-error-900
    `,
      gradient: `
      bg-gradient-to-br from-primary/5 to-secondary/5 
      border-primary/10 
    `,
    };

    const hoverStyles = hover
      ? `
    hover:shadow-card-hover hover:-translate-y-1 cursor-pointer
  `
      : "";

    const cardClasses = twMerge(baseStyles, variants[variant], hoverStyles, className);

    return (
      <div ref={ref} className={cardClasses} {...props}>
        {children}
      </div>
    );
  }
);

Card.displayName = "Card";

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={twMerge("flex flex-col space-y-1.5 p-6", className)} {...props} />
));
CardHeader.displayName = "CardHeader";

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={twMerge("text-2xl font-semibold leading-none tracking-tight", className)}
    {...props}
  />
));
CardTitle.displayName = "CardTitle";

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} className={twMerge("text-sm text-neutral-500", className)} {...props} />
));
CardDescription.displayName = "CardDescription";

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={twMerge("p-6 pt-0", className)} {...props} />
));
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={twMerge("flex items-center p-6 pt-0", className)} {...props} />
));
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
